export const PRIVACY_SETTINGS_PATH = '/privacy-settings';

export const routePaths = {
  PRIVACY_SETTINGS_PATH
};

export default routePaths;
